import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui-kit/dropdown-menu';
import { Button } from '@/components/ui-kit/button';
import { EllipsisVertical, Trash, ExternalLink, Search } from 'lucide-react';
import { useState } from 'react';
import { DeleteAgent } from './delete-agent';
import { useTranslation } from 'react-i18next';
import { AgentSummary } from '@/modules/gpt-chats/types/agent.service.type';
import { Link } from 'react-router-dom';

export const AgentCardDropDown = ({ agent }: { agent: AgentSummary }) => {
  const { t } = useTranslation();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="-mt-1 h-fit w-fit rounded-full p-2 hover:bg-accent/50"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <EllipsisVertical className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <DropdownMenuItem asChild>
            <Link
              to={`/ai/agent-details/${agent.id}`}
              className="flex items-center w-full"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <ExternalLink className="mr-2 h-4 w-4" />
              <span>{t('OPEN')}</span>
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link
              to={`/ai/agent-details/${agent.id}/retrieval-testing`}
              className="flex items-center w-full"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Search className="mr-2 h-4 w-4" />
              <span>{t('RETRIEVAL_TESTING')}</span>
            </Link>
          </DropdownMenuItem>
          {/* <DropdownMenuItem asChild>
            <Link
              to={`/ai/agent-details/${agent.id}/integrations`}
              className="flex items-center w-full"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Plug className="mr-2 h-4 w-4" />
              <span>{t('INTEGRATIONS')}</span>
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link
              to={`/ai/agent-details/${agent.id}/conversations`}
              className="flex items-center w-full"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <MessageSquare className="mr-2 h-4 w-4" />
              <span>{t('CONVERSATIONS')}</span>
            </Link>
          </DropdownMenuItem> */}
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation();
              setIsDeleteModalOpen(true);
            }}
            className="text-destructive focus:text-destructive focus:bg-destructive/10"
          >
            <Trash className="mr-2 h-4 w-4" />
            <span>{t('DELETE')}</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <DeleteAgent
        agentId={agent.id}
        open={isDeleteModalOpen}
        onOpenChange={setIsDeleteModalOpen}
      />
    </>
  );
};
